/* PH_PDP_V1 — Move the "Shipping calculated at checkout" note to sit directly under the price. Ref: sops/web-design.md */
(function () {
  function place() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var price = info.querySelector('[id^="price-"]');
    var tax = info.querySelector('.product__tax');
    if (price && tax && price.nextElementSibling !== tax) {
      price.insertAdjacentElement('afterend', tax);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
  document.addEventListener('shopify:section:load', place);
})();


/* PH_PDP_RATING_SCROLL_V2 — native rating under the product title is clickable; scrolls to the reviews block (handles Vitals lazy-load). */
(function () {
  function target() {
    return document.querySelector('[id*="vitals_product_reviews"]')
        || document.getElementById('bundle-product_reviews')
        || document.querySelector('.Vtl-AppBlock');
  }
  function scrollTo(t) {
    var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  function go(e) {
    if (e) e.preventDefault();
    var t = target(); if (!t) return;
    if (t.getBoundingClientRect().height >= 40) { scrollTo(t); return; }
    // reviews not loaded yet: jump to the bottom to trigger Vitals lazy-load, then refine
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'auto' });
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var tt = target();
      if ((tt && tt.getBoundingClientRect().height >= 40) || tries > 25) {
        clearInterval(iv);
        if (tt) scrollTo(tt);
      }
    }, 150);
  }
  function wire() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return;
    var wrap = info.querySelector('.rating-wrapper') || info.querySelector('.rating');
    if (!wrap || wrap.dataset.phReviewsLink) return;
    wrap.dataset.phReviewsLink = '1';
    wrap.style.cursor = 'pointer';
    wrap.setAttribute('role', 'button');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('aria-label', 'Read all reviews');
    wrap.addEventListener('click', go);
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    var cnt = info.querySelector('.rating-count span[aria-hidden="true"]');
    if (cnt && !cnt.dataset.phRc) {
      cnt.dataset.phRc = '1';
      cnt.innerHTML = cnt.innerHTML.replace(/(\()(\s*[\d.,]+\s*)(\))/, '$1<span class="ph-rc-num">$2</span>$3');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  document.addEventListener('shopify:section:load', wire);
})();


/* PH_VERIFIED_BUYER_BADGE_V2 — inject "Verified Buyer" badge inline inside the date element (grey, aligns with date on mobile) */
(function () {
  var BADGE_HTML = '<span class="ph-verified-badge" aria-label="Verified Buyer" style="display:inline-flex;align-items:center;gap:3px;margin-left:8px;font-size:0.85em;font-weight:600;color:#6b7280;white-space:nowrap;vertical-align:middle;">'
    + '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true" style="flex-shrink:0">'
    + '<circle cx="6" cy="6" r="6" fill="#6b7280"/>'
    + '<path d="M3.5 6l1.8 1.8L8.5 4.5" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>Verified Buyer</span>';

  function inject() {
    document.querySelectorAll('.vtl-pr-ri__date').forEach(function (el) {
      if (el.dataset.phVb) return;
      el.dataset.phVb = '1';
      el.insertAdjacentHTML('beforeend', BADGE_HTML);
    });
  }

  function observe() {
    var target = document.querySelector('[id*="vitals_product_reviews"]') || document.querySelector('.Vtl-AppBlock') || document.body;
    new MutationObserver(inject).observe(target, { childList: true, subtree: true });
    inject();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
  document.addEventListener('shopify:section:load', observe);
})();
